/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import React, { useEffect, useState } from "react";
import axios from "axios";

/**
 *
 * @param url string - url for making http call
 * @param config object - for request headers
 * @returns object - isLoading, data, error
 */
const useFetch = (url: string, config: any) => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<any>();
  const [error, setError] = useState<any>();
  const [statusCode, setstatusCode] = useState<any>();
  useEffect(() => {
    setLoading(true);
    axios
      .get(url, config)
      .then((response) => {
        setLoading(false);
        setData(response.data);
        setstatusCode(response.status);
      })
      .catch((error) => {
        setLoading(false);
        setError(error);
      });
  }, []);

  return { isLoading, data, error, statusCode };
};

export default useFetch;
